import { ts } from "@/plugins/i18n-formatted"

/**
 * @todo
 * - focus na zadavani casu u handicapu
 * - enter pri zadavani casu ma zavrit okno
 * - jak se to ma chovat pri prime volbe cisla plachty
 * - pri zadavani casu/oprave casu kontrolovat, ze je vyssi nez zacatek rozjizdky
 * - editace zadar (desetinna cisla)
 * - u PY pocitat average lap schema
 * - proverit ten Texel
 */

const handicapSystems = [ null, 'zadar', 'texel', 'RsT', 'RsA' ]  // 'pynumber', 'pylist', 'th'

const handicapLists	: Record<string, Record<string, number>> = {
	'pylist': {
		'4000': 923,
		'420': 1110,
		'470': 973,
		'505': 896,
		'2000': 1121,
		'2.4mR': 1244,
		'29er': 900,
		'49er': 697,
		'49erFX': 720,
		'Albacore': 1037,
		'Alto': 921,
		'B14': 858,
		'Blaze': 1030,
		'British Moth': 1165,
		'Byte CII': 1129,
		'Comet': 1208,
		'Comet Trio Mk 1': 1088,
		'Comet Trio Mk 2': 1053,
		'Contender': 969,
		'Devoti D-One': 955,
		'Devoti D-Zero': 1029,
		'Enterprise': 1137,
		'Europe / Evropa': 1140,
		'Finn': 1049,
		'Fireball': 959,
		'Firefly': 1174,
		'Flying Fifteen': 1028,
		'Flying Dutchman': 879,
		'GP 14': 1141,
		'Graduate': 1100,
		'Hadron H2': 1045,
		'Hornet': 955,
		'ILCA 4': 1216,
		'ILCA 6': 1154,
		'ILCA 7': 1104,
		'K1': 1065,
		'K6': 910,
		'Kestrel': 1042,
		'Lark': 1060,
		'Laser 2000': 1107,
		'Laser II': 1085,
		'Laser Pico': 1330,
		'Laser Radial': 1150,
		'Laser SB20': 911,
		'Laser Stratos': 1103,
		'Laser EPS': 1033,
		'Lightning 368': 1168,
		'Megabyte': 1060,
		'Melges 24': 846,
		'Merlin Rocket': 983,
		'Miracle': 1196,
		'Mirror (D/H)': 1368,
		'Mirror (S/H)': 1375,
		'Musto Skiff': 834,
		'OK': 1095,
		'Optimist': 1631,
		'Osprey': 932,
		'Phantom': 998,
		'Rooster 8.1': 1021,
		'RS Aero 5': 1139,
		'RS Aero 6': 1099,
		'RS Aero 7': 1063,
		'RS Aero 9': 1005,
		'RS Elite': 938,
		'RS Feva S': 1280,
		'RS Feva XL': 1244,
		'RS Neo': 1147,
		'RS Quba': 1295,
		'RS Quest': 1130,
		'RS Tera PRO': 1370,
		'RS Tera Sport': 1445,
		'RS Vareo': 1095,
		'RS Vision': 1145,
		'RS Zest': 1228,
		'RS100 8.4': 1001,
		'RS100 10.2': 981,
		'RS200': 1050,
		'RS200 No Spinnaker': 1065,
		'RS300': 965,
		'RS400': 942,
		'RS500': 963,
		'RS600': 921,
		'RS600 FF': 550,
		'RS700': 845,
		'RS800': 799,
		'Scorpion': 1042,
		'Seafly': 1077,
		'Splash': 1247,
		'Snipe': 1110,
		'Solo': 1139,
		'Star': 1142,
		'Solution': 1108,
		'Streaker': 1124,
		'Supernova': 1075,
		'Tasar': 1019,
		'Topaz Argo': 1075,
		'Topaz Duo': 1190,
		'Topaz Magno': 1175,
		'Topaz Omega': 1075,
		'Topaz Uno': 1251,
		'Topaz Vibe': 1185,
		'Topaz Xenon': 1100,
		'Topper': 1363,
		'Topper 4.2': 1440,
		'Vaurien': 1140,
		'Vortex': 950,
		'Waszp': 620,
		'Wanderer': 1201,
		'Wayfarer': 1109,
		'Blaze Fire': 1050,
		'Buzz': 1006,
		'Byte CI': 1217,
		'Cadet': 1455,
		'Devoti D-Zero Black rig': 1057,
		'Fusion Pro': 1290,
		'Fusion Pro Gen': 1275,
		'International Canoe': 847,
		'Mirror No Spinnaker': 1371,
		'Hansa 303 (S/H)': 1580,
		'Hansa Liberty': 1423,
		'Tornado': 637
	},
	'RsT': {
		'RS Tera Sport': 1445,
		'RS Tera PRO': 1370
	},
	'RsA': {
		'RS Aero 5': 1070,
		'RS Aero 6': 1040,
		'RS Aero 7': 1000,
		'RS Aero 9': 960
	}
}

const defaultHandicap: Record<string, string> = {
	'pynumber': '1000',
	'zadar': '1',
	'texel': '100',
	'th': '1',
	'pylist': 'Optimist',
	'RsT': 'RS Tera Sport',
	'RsA': 'RS Aero 7'
}

export function allHandicapSystems () {
	return handicapSystems
		.map( ( system ) => ( { value: system, label: ts( system === null ? 'handicapSystem-none' : 'handicapSystem-' + system ) } ) )
		.sort( ( a, b ) => a.value === null ? -1 : ( b.value === null ? 1 : a.label.localeCompare( b.label ) ) )
}

export function allHandicaps ( system: string ) {
	return Object.hasOwn( handicapLists, system )
		? Object.entries( handicapLists[ system ] )
				.map( ( item ) => ( { value: item[ 1 ], label: item[ 0 ] } ) )
				.sort( ( a, b ) => a.label.localeCompare( b.label ) )
		: null
}

export function getDefaultHandicap ( system: string ) {
	return defaultHandicap[ system ] ?? ''
}

export const handicapBaseDate = '2022-01-01'